"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const if_defined_js_1 = require("lit/directives/if-defined.js");
const button_styles_1 = require("@/components/common/button/button.styles");
require("@/components/common/dot/semantics/current-indicator");
const dot_styles_1 = require("@/components/common/dot/dot.styles");
require("@/components/common/icon");
const shared_styles_1 = require("@/stylesheets/shared.styles");
let Button = class Button extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.variant = 'tertiary';
        this.size = 'medium';
        this.fullWidth = false;
        this.type = 'button';
        this.disabled = false;
        this.iconPosition = 'leading';
        this.ariaLabel = '';
        this.ariaExpanded = null;
        this.ariaHasPopup = null;
        this.ariaControls = null;
        this.ariaCurrent = null;
    }
    render() {
        return (0, lit_1.html) `
      <button
        type=${this.type}
        ?disabled=${this.disabled}
        aria-label=${this.ariaLabel || lit_1.nothing}
        aria-expanded=${(0, if_defined_js_1.ifDefined)(this.ariaExpanded ?? undefined)}
        aria-haspopup=${(0, if_defined_js_1.ifDefined)(this.ariaHasPopup ?? undefined)}
        aria-controls=${(0, if_defined_js_1.ifDefined)(this.ariaControls ?? undefined)}
        aria-current=${(0, if_defined_js_1.ifDefined)(this.ariaCurrent ?? undefined)}
        @click=${this.handleClick}
      >
        ${this.renderIcon('leading')}
        <slot></slot>
        ${this.renderIcon('trailing')} ${this.renderCurrentIndicator()}
      </button>
    `;
    }
    handleClick(event) {
        if (this.disabled) {
            event.preventDefault();
            event.stopPropagation();
        }
    }
    renderCurrentIndicator() {
        if (!this.ariaCurrent || this.ariaCurrent === 'false')
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-current-indicator></mm-current-indicator>
    `;
    }
    renderIcon(position) {
        if (!this.icon || this.iconPosition !== position)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-icon name=${this.icon}></mm-icon>
    `;
    }
};
Button.styles = [
    shared_styles_1.resetStyles,
    button_styles_1.buttonBaseStyles,
    button_styles_1.buttonSizeStyles,
    button_styles_1.buttonVariantStyles,
    (0, lit_1.css) `
      button[aria-current] {
        position: relative;
      }

      mm-current-indicator {
        ${dot_styles_1.dotBelowStyles};
      }
    `,
];
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], Button.prototype, "variant", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], Button.prototype, "size", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean, attribute: 'full-width', reflect: true })
], Button.prototype, "fullWidth", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], Button.prototype, "type", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], Button.prototype, "disabled", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], Button.prototype, "icon", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'icon-position' })
], Button.prototype, "iconPosition", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'aria-label' })
], Button.prototype, "ariaLabel", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'aria-expanded' })
], Button.prototype, "ariaExpanded", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'aria-haspopup' })
], Button.prototype, "ariaHasPopup", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'aria-controls' })
], Button.prototype, "ariaControls", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'aria-current', reflect: true })
], Button.prototype, "ariaCurrent", void 0);
Button = __decorate([
    (0, decorators_js_1.customElement)('mm-button')
], Button);
exports.Button = Button;
//# sourceMappingURL=data:application/json;base64,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